export const SELECTED_RETAILER="SELECTED_RETAILER"